import { useRouter } from 'next/router';
import { useProductPageStatus } from '@elem/compPage/DPUX/ProductProvider';
import { useState, useEffect } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { IPageStatus } from '@elem/compPage/DPUX/config/IPageStatus';

export default function Modal({ callback }: any) {
    const { t } = useLang('dpux');
    const { locale = '' } = useRouter();
    const pageStatus = useProductPageStatus();

    const [visible, setVisible] = useState(false);

    let status = 0;
    if (pageStatus === IPageStatus.SUPER_EARLY) {
        status = 1;
    } else if (pageStatus === IPageStatus.EARLY) {
        status = 2;
    }

    const handleClose = () => {
        setVisible(false);
        setTimeout(() => {
            callback();
        }, 200);
    };

    useEffect(() => {
        setTimeout(() => {
            setVisible(true);
        }, 200);
    }, []);

    return (
        <div
            className={`dpux-modal-terms ${css.modal} GtmModuleData-section ${visible ? 'visible' : ''}`}
            data-section-id={css.modal}
            data-section-title={t('D_memo')}
        >
            <div className="mask" onClick={handleClose}></div>
            <div className={`content ${visible ? 'visible' : ''}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none" onClick={handleClose}>
                    <circle cx="10" cy="10" r="10" fill="white" fillOpacity="0.4" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.76758 9.82812L6.46918 12.1265C6.17629 12.4194 6.17629 12.8943 6.46918 13.1872C6.76207 13.4801 7.23695 13.4801 7.52984 13.1872L9.82824 10.8888L12.1266 13.1872C12.4195 13.4801 12.8944 13.4801 13.1873 13.1872C13.4802 12.8943 13.4802 12.4194 13.1873 12.1265L10.8889 9.82812L13.1867 7.53033C13.4796 7.23744 13.4796 6.76256 13.1867 6.46967C12.8938 6.17678 12.4189 6.17678 12.126 6.46967L9.82824 8.76746L7.53045 6.46967C7.23755 6.17678 6.76268 6.17678 6.46979 6.46967C6.17689 6.76256 6.17689 7.23744 6.46979 7.53033L8.76758 9.82812Z"
                        fill="white"
                    />
                </svg>
                <p className="modal-title">{t('D_memo')}</p>
                <p className="modal-text">
                    {t.rich(`D_memo_text_${status}`, {
                        a: (v: string) => (
                            <a className="link" href={`https://${v}`} target="_blank" rel="noreferrer">
                                {v}
                            </a>
                        ),
                        b: (v: string) => <b className="tit">{v}</b>,
                        install: (v: string) => (
                            <a className="link" href={`https://${locale}.ecoflow.com/pages/installation-terms-conditions`} target="_blank" rel="noreferrer">
                                {v}
                            </a>
                        ),
                        mail: (v: string) => (
                            <a className="link" href={`mailto:${v}`} target="_blank" rel="noreferrer">
                                {v}
                            </a>
                        ),
                        R1: (v: string) => (
                            <a className="link" href={`https://${locale}.ecoflow.com/pages/return-refund-policy`} target="_blank" rel="noreferrer">
                                {v}
                            </a>
                        ),
                        R2: (v: string) => (
                            <a className="link" href={`https://${locale}.ecoflow.com/pages/ecoflow-return-policy`} target="_blank" rel="noreferrer">
                                {v}
                            </a>
                        ),
                        oshipping: (v: string) => (
                            <a className="link" href={`https://${locale}.ecoflow.com/pages/order-processing-shipping-policy`} target="_blank" rel="noreferrer">
                                {v}
                            </a>
                        ),
                        shipping: (v: string) => (
                            <a className="link" href={`https://${locale}.ecoflow.com/pages/shipping-policy`} target="_blank" rel="noreferrer">
                                {v}
                            </a>
                        ),
                        p: (v: string) => <span style={{ textDecoration: 'underline', color: 'rgba(255, 255, 255, .75)' }}>{v}</span>,
                    })}
                </p>
            </div>
        </div>
    );
}
